var baseUrl = 'https://docs.sanity.io/help/'

module.exports = function generateHelpUrl(slug) {
  return baseUrl + slug
}



// WEBPACK FOOTER //
// ../node_modules/@sanity/generate-help-url/index.js